var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Date:  "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.visitDay)+"T"+_vm._s(_vm.visitTime)+" (Day "+_vm._s(_vm.visitDayNum)+")")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }